import { Link } from '@material-ui/core';
import React, { FC, ReactChildren, ReactChild } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface CustomLinkProps {
  children?: ReactChild | ReactChildren;
  color?: 'inherit' | 'initial' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';
  style?: object;
  link?: string | false;
}
const CustomLink: FC<CustomLinkProps> = ({ children, color = 'textPrimary', style = { textDecoration: 'none', cursor: 'pointer' }, link }) => {
  return (
    <>
      {link !== false ? <Link color={color} style={style} component={RouterLink} to={link} >
        {children}
      </Link > : children}
    </>
  );
};

export default CustomLink;
